module.exports = __webpack_public_path__ + "static/media/link.b6c94f54.svg";